import React from "react";
import { AppDetails } from "../../configs";

function Footer() {
  return (
    <div className="text-primary-main relative bottom-0 w-full h-100 py-3 bg-secondary-medium shadow-xl">
      <footer className="flex items-center justify-center flex-grow">
        <div className="relative h-200">
          <p>
            &copy; {new Date().getFullYear()} {AppDetails.app.name}. All rights
            reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
